import * as Yup from "yup";

const today = new Date();

const ValidationSchema = Yup.object({
  // facilityName: Yup.string().required("Required"),
  // facilityAlias: Yup.string(),
  // facilityActive: Yup.object().shape({
  //   label: Yup.string().required(),
  //   value: Yup.string()
  //     .oneOf(["Y", "N"], "Facility Active must be either True or False")
  //     .required("Required"),
  // }),
  // facilityInactiveDate: Yup.date()
  //   .nullable()
  //   .default(null)
  //   .typeError("Must be a Date")
  //   .max(today, "Date cannot be in the future"),
  // facilityUSEPA: Yup.object().shape({
  //   label: Yup.string().required(),
  //   value: Yup.string()
  //     .oneOf(["Y", "N"], "Facility US EPA must be either True or False")
  //     .required("Required"),
  // }),
  // facilityEPAIDType: Yup.object()
  //   .required("Required")
  //   .shape({
  //     label: Yup.string().required(),
  //     value: Yup.string()
  //       .oneOf(["T", "P"], "EPA ID Type must be either Temporary or Permanent")
  //       .required("Required"),
  //   }),
  // facilityMediaType: Yup.object()
  //   .required("Required")
  //   .shape({
  //     label: Yup.string().required(),
  //     value: Yup.string()
  //       .oneOf(
  //         ["System", "Manual"],
  //         "Media Type must be either System or Manual"
  //       )
  //       .required("Required"),
  //   }),
  // facilityEPAID: Yup.string()
  //   .length(12, "EPAIDs must be 12 characters long")
  //   .matches(/(ca*)/i, "EPA IDs must start with CA", {
  //     excludeEmptyString: true,
  //   })
  //   .required("Required"),
  // facilityFEIN: Yup.string(),
  // facilityBOENumber: Yup.string(),
  // locationStreet1: Yup.string().required("Required"),
  // locationStreet2: Yup.string(),
  // locationCity: Yup.string().required("Required"),
  // locationState: Yup.object().shape({
  //   label: Yup.string().required(),
  //   value: Yup.string().required("Required"),
  // }),
  // locationZip: Yup.string()
  //   .matches(/^9/, "Postal Code must start with 9", {
  //     excludeEmptyString: true,
  //   })
  //   .required("Required"),
  // locationCounty: Yup.string().required("Required"),
  // locationRegion: Yup.object().shape({
  //   label: Yup.string().required(),
  //   value: Yup.string().required("Required"),
  // }),
  // locationCUPA: Yup.object().nullable().shape({
  //   label: Yup.string(),
  //   value: Yup.string(),
  // }),
  // mailingAttention: Yup.string(),
  // mailingStreet1: Yup.string().required("Required"),
  // mailingStreet2: Yup.string(),
  // mailingCity: Yup.string().required("Required"),
  // mailingState: Yup.object().shape({
  //   label: Yup.string().required(),
  //   value: Yup.string().required("Required"),
  // }),
  // mailingZip: Yup.string().required("Required"),
  // contactName: Yup.string().required("Required"),
  // contactStreet1: Yup.string().required("Required"),
  // contactStreet2: Yup.string(),
  // contactCity: Yup.string().required("Required"),
  // contactState: Yup.object().shape({
  //   label: Yup.string().required(),
  //   value: Yup.string().required("Required"),
  // }),
  // contactZip: Yup.string().required("Required"),
  // contactPhone: Yup.string().required("Required"),
  // contactMedia: Yup.object().shape({
  //   label: Yup.string().required(),
  //   value: Yup.string().required("Required"),
  // }),
  // contactEmail: Yup.string().required("Required"),
  // ownerName: Yup.string().required("Required"),
  // ownerStreet1: Yup.string().required("Required"),
  // ownerStreet2: Yup.string(),
  // ownerCity: Yup.string().required("Required"),
  // ownerState: Yup.object().shape({
  //   label: Yup.string().required(),
  //   value: Yup.string().required("Required"),
  // }),
  // ownerZip: Yup.string().required("Required"),
  // ownerPhone: Yup.string().required("Required"),
  // callerBusiness: Yup.string(),
  // callerName: Yup.string(),
  // callerStreet1: Yup.string(),
  // callerStreet2: Yup.string(),
  // callerCity: Yup.string(),
  // callerState: Yup.object().shape({
  //   label: Yup.string(),
  //   value: Yup.string(),
  // }),
  // callerZip: Yup.string(),
  // callerPhone: Yup.string(),
  // callerEmail: Yup.string(),
  // facilityComments: Yup.string().nullable(),
  // facilityNaics: Yup.array().of(Yup.object()).required("Required"),
  // facilityTypes: Yup.array().of(Yup.object()).required("Required"),
});

export default ValidationSchema;
